import '../components/_photoswipe'
import '../utils/_smooth-anchors'

import GoogleMap from '../components/map/_map';
import {mapStyle} from '../components/map/include/_mapStyle';

function initMap() {

    let mapInfos = document.querySelector('[js-map-container]');
    let officeInfos = document.querySelector('[js-office-popup]');
    let ProgrammInfos = document.querySelector('[js-program-popup]');

    let iconUri = mapInfos.dataset.iconUri;

    let agencyLat = null;
    let agencyLng = null;
    let programmLat;
    let programmLng;
    let initialPosition;
    let initialPositionLat;
    let initialPositionLng;
    let bounds = new google.maps.LatLngBounds();
    let hasMultiplePoint = false;

    if (officeInfos) {
        agencyLat = parseFloat(officeInfos.dataset.lat);
        agencyLng = parseFloat(officeInfos.dataset.lng);

        let agencyPoint = new google.maps.LatLng(agencyLat, agencyLng);
        bounds.extend(agencyPoint);
    }

    //check if programm adress exists
    if (ProgrammInfos) {
        programmLat = parseFloat(ProgrammInfos.dataset.lat);
        programmLng = parseFloat(ProgrammInfos.dataset.lng);

        //set center between both markers
        if (officeInfos) {
            initialPositionLat = (programmLat + agencyLat) / 2;
            initialPositionLng = (programmLng + agencyLng) / 2;
        } else {
            initialPositionLat = programmLat;
            initialPositionLng = programmLng;
        }

        initialPosition = new google.maps.LatLng(initialPositionLat, initialPositionLng);

        let programmPoint = new google.maps.LatLng(programmLat, programmLng);
        bounds.extend(programmPoint);

        if (officeInfos) {
            ProgrammLocator.multipleMarkers(true)
            hasMultiplePoint = true;
        }
    } else if (!ProgrammInfos && officeInfos) {

        initialPosition = new google.maps.LatLng(agencyLat, agencyLng);
    }

    ProgrammLocator.init({
        mapContainerSelector: '#program-locator',
        center: initialPosition,
        address: '',
        streetViewControl: false,
        mapTypeControl: false,
        zoomControl: true,
        zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_BOTTOM,
        },
        fullscreenControl: false,
        styles: mapStyle,
    });

    ProgrammLocator.fitBounds(bounds, hasMultiplePoint);
    ProgrammLocator.setIconUri(iconUri);

    if (officeInfos) {
        ProgrammLocator.setMarkers(agencyLat, agencyLng);
    }

    if (ProgrammInfos) {
        ProgrammLocator.setMarkers(programmLat, programmLng);
    }
}

const ProgrammLocator = (function () {

    let self = {};

    let model = {
        map: null,
        currentPosition: {
            lat: null,
            lng: null,
        },
        currentAddress: null,
        product: null,
        radius: 40,
        defaultRadius: 40,
        request: null,
        initialPosition: null,
    };

    let markers = [];
    let multipleMarkers = false;
    let iconBase;

    self.init = (options) => {
        model.map = new GoogleMap(options);
    };

    self.setIconUri = (iconUri) => {
        iconBase = iconUri;
    }

    self.multipleMarkers = (result) => {
        multipleMarkers = result;
    }

    self.fitBounds = (bounds, hasMultiplePoint) => {
        let map = model.map;

        if (hasMultiplePoint) {
            map.fitBounds(bounds);

        } else {
            map.setZoom(13);
        }

        map.panToBounds(bounds);
    }

    self.setMarkers = (lat, lng) => {

        const coords = new google.maps.LatLng(lat, lng);

        let map = model.map;
        let iconPath = iconBase + 'place-map.svg';

        if (multipleMarkers) {
            iconPath = iconBase + 'place-map-secondary.svg';
        }

        const marker = new google.maps.Marker({
            position: coords,
            map,
            icon: iconPath,
        });

        //ajout des markers dans un array
        markers.push(marker);

        marker.addListener('click', function () {
            //centre la map
            model.map.panTo(marker.getPosition());

            if (multipleMarkers) {
                //supprime les pins actifs
                for (let i = 0; i < markers.length; i++) {
                    const mark = markers[i];
                    mark.setIcon(iconBase + 'place-map-secondary.svg')
                }

                // ajout du pin cliqué actif
                marker.setIcon(iconBase + 'place-map.svg');

                setActiveInfos(marker.getPosition());
            }
        });

        return marker;
    }

    function setActiveInfos(activeCoords) {
        let activeLat = activeCoords.lat();
        let activeLng = activeCoords.lng();
        let activeClass = 'is-visible';

        let officeInfos = document.querySelector('[js-office-popup]');
        let ProgrammInfos = document.querySelector('[js-program-popup]');

        if (officeInfos.classList.contains(activeClass)) {
            officeInfos.classList.remove(activeClass);
        }
        if (ProgrammInfos.classList.contains(activeClass)) {
            ProgrammInfos.classList.remove(activeClass);
        }

        let activeInfos = document.querySelector(`[data-lat="${activeLat}"]`);
        activeInfos.classList.add(activeClass);
    }

    return self;
}());

const pswpImage = document.querySelector('[js-pswp-image]');
const pswpToggler = document.querySelector('[js-pswp-toggler]');

if (pswpToggler && pswpImage) {
    pswpToggler.addEventListener('click', () => {
        pswpImage.click();
    })
}

const iframeToggler = document.querySelectorAll('[js-iframe-toggler]');
const iframeContainer = document.querySelector('[js-iframe]');
const openedClass = 'jsmodal--opened';

if (iframeToggler) {
    iframeToggler.forEach( (toggler) => {
        console.log(toggler);
        toggler.addEventListener('click', () => {
            console.log(toggler);
            if (iframeContainer.classList.contains(openedClass)) {
                iframeContainer.classList.remove(openedClass);
            } else {
             iframeContainer.classList.add(openedClass);
            }
         });
    });
}

window.initMap = initMap;
